import toast from "react-hot-toast"
import moment from "moment"

export const handleError = (error) => {
    console.log("error", error)
    const thisError = error || {}
    const errorCode = thisError.code
    let message = "Something went wrong"

    switch (errorCode) {
        case "auth/user-not-found":
        case "auth/wrong-password":
            message = "Invalid credentials"
            break;
    
        default:
            message = thisError.message || message
            break;
    }

    toast.error(message, {
        position: "top-right",
        duration: 4000
    })
}

export const getDataFromResponse = (data) => {
    if (data) {
        let actualData = []
        data.forEach(doc => {
            actualData.push(doc.data())
        })
        return actualData
    }
    return []
}

export const getValuesFromSelect = (data) => {
    if (data && Array.isArray(data)) {
        return data.map(d => d.value)
    } else if (data && typeof data === "object") {
        return data.value
    }
    return undefined
}

export const formatValuesForSelect = (data, labelKey, valueKey) => {
    if (data) {
        let actualData = []
        data.forEach(doc => {
            actualData.push({
                value: valueKey === "id" ? doc.id : doc.data()[valueKey],
                label: doc.data()[labelKey]
            })
        })
        return actualData
    }
    return []
}

export const formatListForOptions = (list, optionsList) => {
    let newList = []
    if (list && optionsList) {
        list.forEach((listItem) => {
            const foundIndex = optionsList.findIndex(option => option.value  === listItem)
            newList.push(optionsList[foundIndex])
        })
        return newList
    }
    return newList
}

export const objectDeepClone = (obj) => {
    return typeof obj === "object" ? JSON.parse(JSON.stringify(obj)) : obj
}

export const getCurrentTimeInMS = () => {
    return moment().valueOf()
}

export const getFileExtension = (fileName) => {
    if (fileName) {
        return fileName.substring(fileName.lastIndexOf('.')+1, fileName.length) || fileName;
    }
    return ""
}

export const formatDateFromEpoch = (epochTime, format = 'DD MMM YY h:mm A') => {
    return moment(epochTime).format(format)
}

export const round = (num) => {
    if (Number(num)) {
        return Math.round((num + Number.EPSILON) * 100) / 100
    }
    return num
}

export const unEscape = (htmlStr) => {
    htmlStr = htmlStr.replace(/&lt;/g , "<")
    htmlStr = htmlStr.replace(/&gt;/g , ">")
    htmlStr = htmlStr.replace(/&quot;/g , "\"")
    htmlStr = htmlStr.replace(/&#39;/g , "\'")
    htmlStr = htmlStr.replace(/&amp;/g , "&")
    return htmlStr
}

export const blobToFile = (theBlob, fileName) => {
    //A Blob() is almost a File() - it's just missing the two properties below which we will add
    theBlob.lastModifiedDate = new Date();
    theBlob.name = fileName;
    return theBlob;
}